
export class LineInformation {
}
// Models
export  class InventoryModel {
    companyId: string;
    typeId: string;
    contactId: string;
    mpnId: string;
    mfrId: string;
    description: string;
    internalPartNumber: string;
    unitCost: string;
    standardPackagingName: string;
    spq: string;
    uom: string;
    warehouse: string;
    location: string;
    receivedInId: string;
    receivedPackagingId: string;
    notes: string;
    inventoryLineModel: InventoryLineModel[];
  }
  
  export  class InventoryLineModel {
    partInventoryId: string;
    qty: number;
    dateCodeYearId: string;
    dateCodeWeekId: string;
    lotCode: string;
    rohsId: string;
    conditionId: string;
    cooId: string;
    splitLine: boolean;
    rowNumber: number;
    splitLineModel: SplitLineModel[];
    serialNumberModel: SerialNumberModel[];
    lineImagesModel: LineImagesModel[];
  }
  export  class LineImagesModel {
    inventoryLineId: string = '';
    tempDocumentId:  any[] = [];
    imageUploadList:  any[] = [];
    }
 export class SplitLineImagesModel extends LineImagesModel {
  splitLineId: string = '';
 }

  export  class SplitLineModel {
    partInventoryId: string;
    partConsignmentId: string;
    inventoryLineId: string;
    qty: number;
    dateCodeYearId: string;
    dateCodeWeekId: string;
    lotCode: string;
    rohsId: string;
    conditionId: string;
    cooId: string;
    rowNumber: number;
    splitLineSerialNumberModel: SplitLineSerialNumberModel[];
    splitLineImagesModel: SplitLineImagesModel[];
    count: any;
  }
  
  export  class SplitLineSerialNumberModel {
    splitLineId: string = '';
    inventoryLineId: string  = '';
    serialNumber: SerialNumber[];
  }
  
  export  class SerialNumberModel {
    inventoryLineId: string  = '';
    serialNumber: SerialNumber[];
  }
  
  export  class SerialNumber {
    value: string;
    count: number;
  }
    